import script from "./CaskBaseFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskBaseFooter.vue?vue&type=script&setup=true&lang=js"

import "./CaskBaseFooter.vue?vue&type=style&index=0&id=215dd340&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215dd340"]])

export default __exports__